<template>
  <div>
    <div class="panel panel-default">
      <div class="panel-heading">Баннеры</div>

      <div class="panel-body">

        <div class="loader" v-show="!loaded"></div>

        <div class="row" v-show="loaded">
          <div class="col-md-8">

          </div>
          <div class="col-md-4">
            <button class="btn btn-default pull-right" type="submit" @click="add()">
              Добавить
            </button>
          </div>
        </div>

        <table class="table" v-show="loaded">
          <thead>
          <tr>
            <th>#</th>
            <th>Заголовок-1</th>
            <th>Заголовок-2</th>
            <th class="slider-text">Текст банера</th>
            <th>Сортировка</th>
            <th class="text-right">Действие</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="item in list">
            <td>{{item.id}}</td>
            <td>{{item.pre_title}}</td>
            <td>{{item.title}}</td>
            <td>{{item.text}}</td>
            <td>{{item.sort}}</td>
            <td>
              <button type="button" class="btn btn-default btn-sm pull-right" @click="edit(item)"><span class="glyphicon glyphicon-edit"></span></button>
              <button type="button" class="btn btn-default btn-sm pull-right" @click="del(item.id, item.id)"><span class="glyphicon glyphicon-trash"></span></button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>

    <modal v-model="modalShow" title="Слайде" @hide="modalHide()" @before-close="beforeClose">
      <!--error-->
      <div class="alert alert-danger fade in" v-show="modalError">
        <p>{{modalError}}</p>
      </div>

      <!--form-->
      <form name="modal-form" id="modal-form">
        <div class="form-group">
          <label for="image">Изображение или видео (1905x857)</label>

          <div class="image-wrap" :style="{backgroundImage: 'url('+url+modalData.image+')'}" v-if="!isMp4()">
            <span v-show="!modalData.image">Изображение отсутствует (желательный размер 1905x857)</span>
          </div>

          <div class="image-wrap" v-if="isMp4()">
            <video controls>
              <source :src="url+modalData.image" type="video/mp4">
              Your browser does not support the video tag.
            </video>
          </div>

          <input type="file" id="image">
          <p class="help-block">Выберите изображение для загрузки (1905x857 jpg,png)</p>
        </div>
        <div class="form-group">
          <label for="pre_title" class="control-label">Заголовок-1:</label>
          <input class="form-control" id="pre_title" v-model="modalData.pre_title">
        </div>
        <div class="form-group">
          <label for="title" class="control-label">Заголовок-2:</label>
          <input class="form-control" id="title" v-model="modalData.title">
        </div>
        <div class="form-group">
          <label for="text" class="control-label">Текст банера:</label>
          <textarea class="form-control" rows="3" id="text" v-model="modalData.text"></textarea>
        </div>
        <div class="form-group">
          <label for="sort" class="control-label">Сортировка:</label>
          <input class="form-control" id="sort" v-model="modalData.sort">
        </div>
        <div class="checkbox" style="margin-top:35px;">
          <label>
            <input type="checkbox" v-model="modalData.visible">
            Включить показ на сайте
          </label>
        </div>
      </form>

      <!-- footer -->
      <div slot="footer">
        <btn type="primary" class="pull-left" @click="store()">Сохранить</btn>
        <btn type="default" class="pull-left" @click="close()">Отмена</btn>
      </div>
    </modal>
  </div>
</template>

<script>
  import {api} from './http'
  var config = require('./config')

  export default {
    mounted () {
    },
    data () {
      return {
        url: config.appUrl,
        modalShow: false,
        modalData: {},
        modalError: '',
        categories: [],
        loaded: false,
        list: []
      }
    },
    beforeCreate () {
      this.loaded = false
      api.post('slider/list?type=slider').then(response => {
        this.loaded = true
        this.list = response.data.slides
      })
    },
    methods: {
      isMp4 () {
        var str = '' + this.modalData.image
        return str.match(/\.mp4$/)
      },
      beforeClose () {
      },
      refreshList () {
        this.loaded = false
        api.post('slider/list?type=slider').then(response => {
          this.loaded = true
          this.list = response.data.slides
        })
      },
      add () {
        this.modalShow = true
      },
      edit (item) {
        var copyItem = {}
        Object.assign(copyItem, item)
        this.modalShow = true
        this.modalData = copyItem
      },
      close () {
        this.resetForm()
        this.modalShow = false
        this.modalError = ''
        this.resetModal()
      },
      modalClose () {
        this.resetForm()
        this.modalShow = false
        this.modalError = ''
        this.resetModal()
      },
      modalHide () {
        this.modalClose()
      },
      resetForm () {
        var form = document.querySelector('#modal-form')
        form.reset()
      },
      store () {
        var formData = new FormData()
        for (let key in this.modalData) {
          if (Array.isArray(this.modalData[key])) {
            for (let i in this.modalData[key]) {
              formData.append(key + '[]', this.modalData[key][i])
            }
          } else {
            let val = this.modalData[key] || ''
            formData.append(key, val)
          }
        }

        if (document.querySelector('#image').files.length) {
          var file = document.querySelector('#image').files[0]
          formData.append('image', file)
        }

        formData.append('type', 'slider')

        api.post('slider/store', formData).then(response => {
          if (response.data.success) {
            this.modalClose()
            this.refreshList()
          } else {
            this.modalError = response.data.message
          }
        })
      },
      del (id, name) {
        if (!confirm('Удалить слайдер #' + name)) {
          return
        }
        var formData = new FormData()
        formData.append('id', id)

        api.post('slider/delete', formData)
          .then(res => { this.refreshList() })
      },
      resetModal () {
        this.modalData = {}
      }
    }
  }
</script>

<style>
  .image-wrap {
    width: 370px;
    height: 248px;
    background-size: cover;
    border: 1px solid silver;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .slider-text {
    width: 450px;
  }
</style>



// WEBPACK FOOTER //
// src/components/AdminSlider.vue